import React, { useState } from "react";
import {
  makeStyles,
  Container,
  Grid,
  List,
  ListItem,
  ListItemText,
  BottomNavigation,
  BottomNavigationAction,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import i18next from "../../../../../config/lang/i18n";
import { useSpring, animated } from "react-spring";
import BannerSlider from "../../../../Sliders/BannerSlider";

import FavoriteIcon from "@material-ui/icons/Favorite";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
const useStyles = makeStyles((theme) => ({
  bgStyle: {
    "&:hover": {
      // background: "rgba(0,0,0,.05)",
    },
  },
  imgBg: {
    // backgroundImage:
    //   "url(images/main/airdryer/refri.jpg)",

    position: "absolute",
    zIndex: -2,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: "var(--border-radius-primary)",
    // padding: "40px 38px 45px",
    background: "no-repeat center center",
    // backgroundSize: "50%",
    backgroundSize: "cover",
    "&::before": {
      display: "block",
      width: "100%",
      height: "100%",
      content: '" "',
      opacity: ".4",
      backgroundImage: " linear-gradient(234deg,#394245,#000)",
    },
    // border: "1px solid",
    willChange: "transform",
  },
  objBg: {
    // backgroundImage:
    //   "url(images/main/airdryer/refrigeranted_air_dryer/oad.png)",

    position: "absolute",
    zIndex: -1,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: "var(--border-radius-primary)",
    // padding: "40px 38px 45px",
    background: "no-repeat 93% 50%",
    backgroundSize: "50%",
    filter: "brightness(0.4)",
    // "&::before": {
    //   display: "block",
    //   width: "100%",
    //   height: "100%",
    //   content: '" "',
    //   opacity: ".4",
    //   backgroundImage: " linear-gradient(234deg,#394245,#000)",
    // },
    // border: "1px solid",
    willChange: "transform",
  },
  txtStyle: {
    // color: "black",
    color: "white",
    fontWeight: "bold",
    fontFamily: "Noto Sans KR",
  },

  subtxtStyle: {
    // color: "black",
    color: "white",
    fontFamily: "Noto Sans KR",

    fontWeight: 500,
    fontSize: 16,
  },
  topContainer: {
    [theme.breakpoints.down("md")]: {
      paddingTop: "5rem",
    },
  },
}));

interface AThirdBannerProps {
  children: React.ReactNode | null | string | undefined;
}

function AThirdBanner() {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("xs"));

  const [{ sValue, brightValue, opacityValue }, set] = useSpring(() => ({
    sValue: 1,
    brightValue: 0.4,
    opacityValue: 1,
    // color: "#fff",
  }));

  return (
    <Grid
      xs={!matches ? 4 : 12}
      lg={!matches ? 4 : 12}
      item
      container
      justify="center"
      className={classes.topContainer}
    >
      <animated.article
        // onMouseEnter={() =>
        //   set({ sValue: 1.07, brightValue: 1, opacityValue: 0 })
        // }
        // onMouseLeave={() =>
        //   set({ sValue: 1, brightValue: 0.4, opacityValue: 1 })
        // }
        style={{
          zIndex: 0,
          overflow: "hidden",
          position: "relative",
          width: "calc(100% - 30px)",
          minHeight: 260,
          border: "1px solid #dadce0",
          // boxShadow:"rgba(0, 0, 0, 0.2) 0px 3px 3px -2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px",

          // backgroundImage:
          //   "linear-gradient(45deg,var(--gradient-green-start),var(--gradient-green-end))",
          borderRadius: 26,
          // margin: "15px 0 15px 15px",
          margin: 15,
          boxSizing: "border-box",
          // transform: sValue.interpolate((sValue) => `scale(${sValue}`),
        }}
      >
        <Grid style={{ height: "80%" }}>
          <Grid>
            <BannerSlider />
          </Grid>
        </Grid>
        <Grid
          style={{ height: "20%" }}
          item
          container
          justify={"center"}
          alignContent={"center"}
          alignItems={"center"}
        >
          <Grid
            xs={12}
            item
            container
            justify={"center"}
            alignContent={"center"}
            component={"span"}
            style={{ cursor: "auto" }}
          >
            <Grid
              xs={6}
              item
              container
              justify={"center"}
              alignItems={"center"}
            >
              <Grid item container xs={12}>
                <Grid
                  xs={12}
                  item
                  container
                  justify={"center"}
                  alignContent={"center"}
                  alignItems={"center"}
                  component={"a"}
                  href="https://www.facebook.com/노동인권문화제-111993953918341/"
                  target="_blank"
                >
                  <div style={{ paddingRight: 8, paddingTop: 7 }}>
                    <FacebookIcon style={{ fontSize: 32, color: "#3b5998" }} />
                  </div>
                  <span
                    style={{
                      fontSize: 16,
                      fontFamily: "Noto Sans KR",
                      fontWeight: 700,
                      // color: "#bc1888",
                    }}
                  >
                    페이스북
                  </span>
                </Grid>
              </Grid>
            </Grid>
            <Grid
              xs={6}
              item
              container
              justify={"center"}
              alignContent={"center"}
              alignItems={"center"}
            >
              <Grid item container xs={12}>
                <Grid
                  xs={12}
                  item
                  container
                  justify={"center"}
                  alignContent={"center"}
                  alignItems={"center"}
                  component={"a"}
                  href="https://www.instagram.com/laborhumanright/?hl=ko"
                  target="_blank"
                >
                  <div style={{ paddingRight: 8, paddingTop: 7 }}>
                    <InstagramIcon style={{ fontSize: 32, color: "#e6683c" }} />
                  </div>
                  <span
                    style={{
                      fontSize: 16,
                      fontFamily: "Noto Sans KR",
                      fontWeight: 700,
                      // color: "#bc1888",
                    }}
                  >
                    인스타그램
                  </span>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* <animated.div
          className={classes.imgBg}
          style={{
            opacity: opacityValue.interpolate(
              (opacityValue) => `${opacityValue}`
            ),
          }}
        ></animated.div> */}
        {/* <animated.div
          className={classes.objBg}
          style={{
            filter: brightValue.interpolate(
              (brightValue) => `brightness(${brightValue})`
            ),
          }}
        ></animated.div> */}
      </animated.article>
    </Grid>
  );
}

// export default MainContainer;
export default AThirdBanner;
